export function getXxTrustedFormCertUrl() {
  const inputElement = document.querySelector(
    'input[name="xxTrustedFormToken"]'
  );

  if (!inputElement || !('value' in inputElement)) return '';
  else return inputElement.value as string;
}
